import { render } from "./CounterpartyRow.vue?vue&type=template&id=7afff531&scoped=true&ts=true"
import script from "./CounterpartyRow.vue?vue&type=script&lang=ts"
export * from "./CounterpartyRow.vue?vue&type=script&lang=ts"

import "./CounterpartyRow.vue?vue&type=style&index=0&id=7afff531&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7afff531"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QMenu,QCard,QCardSection,QAvatar,QCardActions,QBtn});qInstall(script, 'directives', {ClosePopup});
